import React from 'react';
import Grid from '@mui/material/Grid';
import { OpenTasks } from './open-tasks';
import { CurrentAssignments } from './current-assignments';

export const Wttp = () => {
  return (
    <Grid container spacing={2} md={12}>
      <CurrentAssignments />
      <OpenTasks />
    </Grid>
  );
};

export default Wttp;
